// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3fthX","name":"Header_name__30BkY","birthday":"Header_birthday__1Vqs0","skeleton":"Header_skeleton__1LSUg"};